var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKbvV16TipsAiSparkle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.07627 11.8638L7.66133 10.5236C8.18207 9.33109 9.11927 8.38175 10.2883 7.86282L11.8988 7.14795C12.4108 6.92069 12.4108 6.17581 11.8988 5.94853L10.3386 5.25598C9.13947 4.7237 8.18547 3.73923 7.67367 2.50598L7.081 1.07784C6.86107 0.547864 6.12879 0.547866 5.90887 1.07784L5.31618 2.50597C4.80438 3.73923 3.85035 4.7237 2.65123 5.25598L1.09105 5.94853C0.579024 6.17581 0.579024 6.92069 1.09105 7.14795L2.70153 7.86282C3.87059 8.38175 4.80781 9.33109 5.3285 10.5236L5.9136 11.8638C6.13851 12.3788 6.85133 12.3788 7.07627 11.8638ZM12.9343 15.1266L13.0988 14.7495C13.3921 14.0771 13.9205 13.5417 14.5797 13.2488L15.0866 13.0236C15.3608 12.9018 15.3608 12.5033 15.0866 12.3815L14.6081 12.1688C13.9319 11.8684 13.3941 11.3132 13.1057 10.618L12.9368 10.2104C12.819 9.92642 12.4263 9.92642 12.3085 10.2104L12.1396 10.618C11.8513 11.3132 11.3135 11.8684 10.6373 12.1688L10.1587 12.3815C9.8846 12.5033 9.8846 12.9018 10.1587 13.0236L10.6657 13.2488C11.3249 13.5417 11.8532 14.0771 12.1465 14.7495L12.3111 15.1266C12.4315 15.4027 12.8138 15.4027 12.9343 15.1266Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKbvV16TipsAiSparkle);
export default __webpack_public_path__ + "static/media/kbv-v16-tips-ai-sparkle.c9e61867edc12c44778e066dbb78a372.svg";
export { ForwardRef as ReactComponent };